import type {Member as MemberGQL} from "../generated";

export class MemberModel implements MemberGQL {
    private readonly member: MemberGQL;

    constructor(member: Partial<MemberGQL>) {
        this.member = {
            id: `${member.id ?? ""}`,
            firstName: member.firstName ?? "",
            lastName: member.lastName ?? "",
            memberId: member.memberId ?? 0,
            imageUrl: member.imageUrl ?? null,
            online: member.online ?? false,
        };
    }

    get id() {
        return this.member.id;
    }

    get memberId() {
        return this.member.memberId;
    }

    get firstName() {
        return this.member.firstName;
    }

    get lastName() {
        return this.member.lastName;
    }

    get imageUrl() {
        return this.member.imageUrl;
    }

    get online() {
        return this.member.online ?? null;
    }

    toGraph = (): MemberGQL => ({
        __typename: "Member",
        ...this.member,
        online: this.online,
    });

    static of(member: Partial<MemberGQL>): MemberModel {
        return new MemberModel(member);
    }

    static toMemberGraph(member: Partial<MemberGQL>): MemberGQL {
        return this.of(member).toGraph();
    }
}
